/**
 * The Sentry environment for an event raised in the browser.
 *
 * The client config used process.env.VERCEL_ENV, which is not exposed to
 * browser code, so it always fell back to NODE_ENV: every browser error,
 * staging's included, arrived labelled "production". The host says where the
 * page really is, and holds for a deployment that is promoted without a
 * rebuild (a build-time value would follow the build, not the domain).
 */
export function browserSentryEnvironment(hostname: string, fallback: string | undefined): string {
  const host = (hostname || '').toLowerCase()
  if (host.startsWith('staging.') || host.includes('.staging.')) return 'staging'
  if (host === 'localhost' || host.startsWith('127.') || host.endsWith('.local')) return 'development'
  return fallback || 'production'
}

/**
 * Headless browsers (scrapers, monitoring probes and our own QA drivers) run
 * pages in ways no buyer does; what they hit is noise in the error feed.
 */
export function isHeadlessBrowser(userAgent: string | undefined | null): boolean {
  return /HeadlessChrome|PhantomJS|Puppeteer|Playwright/i.test(userAgent || '')
}
